import { Suspense, useContext } from 'react';
import './App.css';
import Layout from '../src/Components/Layout/index'
import { BrowserRouter as Router } from "react-router-dom";
import { Container } from "@sainsburys-tech/luna-grid";
import Routes from './Routes/index';
import { store } from './Redux/Store';
import { Provider } from 'react-redux';

import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './authConfig';

import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import LoadingIndicator from '../src/Components/LoadingIndicator'
import { AuthContext } from './Contexts/AuthContext';
import { Authentication } from './Contexts/Authentication'
import WithAxios from './Utils/axios'

const queryClient = new QueryClient();
function App() {

  const authContext = useContext(AuthContext)

  return (

    <AuthContext.Provider value={{ isLoggedin: !!authContext.token, login: ()=>{}, logout: ()=>{}, token: authContext.token }}>
      <Authentication>
        <WithAxios>
          <Provider store={store}>
            <Suspense fallback={<LoadingIndicator props={true} />}>
              <QueryClientProvider client={queryClient}>
                <Router>
                  <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
                    <Layout>
                      <Container>
                        <Routes />
                      </Container>
                    </Layout>
                  </MsalAuthenticationTemplate>
                </Router>
                <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
              </QueryClientProvider>
            </Suspense>
          </Provider>
        </WithAxios>
      </Authentication>
    </AuthContext.Provider >

  );
}

export default App;
